









































































import Vue from 'vue';

import { MDCTextField } from '@material/textfield';
import { MDCRipple } from '@material/ripple';
import { MDCSnackbar } from '@material/snackbar';

import Axios from 'axios';
import JwtDecode from 'jwt-decode';

interface Data {
  email: string;
  password: string;
  passwordConfirmation: string;

  token: string;

  equal: boolean;

  textFields: any[];
  snackbar: any;
}

export default Vue.extend({
  data(): Data {
    return {
      email: '',
      password: '',
      passwordConfirmation: '',

      token: '',

      equal: true,

      textFields: [],
      snackbar: null,
    };
  },
  methods: {
    submit() {
      if (!this.equal) {
        return;
      }

      const vue = this;
      Axios.post('/API/resetPassword', {
        Token: this.token, Password: this.password,
      }).then((result) => {
        vue.snackbar.open();
        setTimeout(() => {
          vue.$router.push('/');
        }, 10 * 1000); // redirect to root in 10 seconds
      }).catch((err: any) => {
        console.warn(err);
      });
    },
  },
  mounted() {
    this.token = this.$route.params.token;
    const jwt: any = JwtDecode(this.token);
    this.email = jwt.sub;

    const vue = this;
    document.querySelectorAll('.mdc-text-field').forEach((element) => {
      const textField = new MDCTextField(element);
      vue.textFields.push(textField);
    });

    // For the card
    const selector = '.mdc-button, .mdc-icon-button, .mdc-card__primary-action';
    const ripples = [].map.call(document.querySelectorAll(selector), (el: any) => {
      return new MDCRipple(el);
    });

    const snackbarElem: any = document.querySelector('.mdc-snackbar');
    this.snackbar = new MDCSnackbar(snackbarElem);
  },
  destroyed() {
    this.snackbar.destroy();
  },
  updated() {
    if (this.password !== this.passwordConfirmation) {
      this.equal = false;
    } else {
      this.equal = true;
    }

    for (const textField of this.textFields) {
      textField.valid = this.equal;
    }
  },
});
